import Link from "../../Link";

const Svelte = () => {
    return (
        <div>
            <Link url="https://www.youtube.com/playlist?list=PLV8x_i1fqBw2QScggh0pw2ATSJg_WHqUN" title={"Svelte Desde 0 - midudev"} />
        </div>
    );
}

export default Svelte;